import SubContainer from '@/components/Container/SubContainer';
import { AdminTabs } from '../components/tabs';
import Container from '@/components/Container';
import Divider from '@/components/Divider';
import { AnnouncementForm } from '@/pages/admin/announcements/components/form';
import { AnnouncementList } from '@/pages/admin/announcements/components/list';
import { useEffect } from 'react';
import { useAnnouncementStore } from '../store/announcementStore';
import { WILDCARD_ADMIN_PAGE_QUERY } from '@/graphql/queries/wildcard/wildcard';
import { useQuery } from '@apollo/client';
import {
  GetWildcardAdminPageQuery,
  GetWildcardAdminPageQueryVariables,
  WildcardAdminPage,
} from '@/graphql/generated/graphql';

export const Announcements = () => {
  const { data } = useQuery<GetWildcardAdminPageQuery, GetWildcardAdminPageQueryVariables>(WILDCARD_ADMIN_PAGE_QUERY);
  const { setPage, page } = useAnnouncementStore();

  useEffect(() => {
    if (data) {
      setPage(data.wildcardAdminPage?.data?.attributes as WildcardAdminPage);
    }
  }, [data, setPage]);

  return (
    <Container>
      <SubContainer className="flex flex-col items-start justify-start px-4 sm:mt-sh-60 lg:col-start-3 lg:col-end-11">
        <AdminTabs />

        <div className="relative flex w-full flex-col items-start justify-start ">
          <h1 className="!text-sh-md font-bold">{page?.title}</h1>
          <p className="mb-sh-30 mt-1 text-sh-sm">{page?.subHeader}</p>

          <AnnouncementForm />

          <Divider />

          <div className="mb-sh-30">
            <h2 className="mb-2 text-sh-sm font-bold">{page?.listTitle}</h2>
            <p className="mb-4 text-sh-xss">{page?.listDescription}</p>
          </div>
          <AnnouncementList />
        </div>
      </SubContainer>
    </Container>
  );
};

export default Announcements;
